export default __webpack_public_path__ + "static/media/leopard.312fd1fc.jpg";